// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.logo {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  vertical-align: middle;
  margin-right: 8px;
  margin-bottom: 8px;
}

.action-wrapper {
  padding-top: 16px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  row-gap: 8px;
  justify-content: flex-end;
}

.sync-action-wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
}

.sync-now-button-text {
  text-transform: capitalize;
  display: inline-block;
  margin-left: 4px;
  white-space: nowrap;
  font-size: 16px;
  font-weight: bold;
}

.sync-now-icon {
  width: 16px;
  height: 16px;
  margin-right: 12px;
}
`, "",{"version":3,"sources":["webpack://./src/components/Settings/integration-card.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB","sourcesContent":[".logo {\n  width: 80px;\n  height: 80px;\n  border-radius: 50%;\n  vertical-align: middle;\n  margin-right: 8px;\n  margin-bottom: 8px;\n}\n\n.action-wrapper {\n  padding-top: 16px;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  row-gap: 8px;\n  justify-content: flex-end;\n}\n\n.sync-action-wrapper {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  width: 100%;\n}\n\n.sync-now-button-text {\n  text-transform: capitalize;\n  display: inline-block;\n  margin-left: 4px;\n  white-space: nowrap;\n  font-size: 16px;\n  font-weight: bold;\n}\n\n.sync-now-icon {\n  width: 16px;\n  height: 16px;\n  margin-right: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
